import * as Type from './actionsTypes';

const savePedidoVoo = (data, callback) => ({ type: Type.PEDIDO_VOO_SAVE, data, callback });

const updatePedidoVoo = (id, data, callback) => ({ type: Type.PEDIDO_VOO_UPDATE, id, data, callback });

const findPedidoVooById = id => ({ type: Type.PEDIDO_VOO_FIND_ONE, id });

const findPedidoVooArquivosById = (id, callback) => ({ type: Type.PEDIDO_VOO_FIND_ARQUIVOS, id, callback });

const validatePedidoVoo = (id, data, callback) => ({ type: Type.PEDIDO_VOO_VALIDATE, id, data, callback });

const deletePedidoVoo = (id, callback) => ({ type: Type.PEDIDO_VOO_DELETE, id, callback });

const pedidoVooClearSelected = () => ({ type: Type.PEDIDO_VOO_CLEAR_SELECTED });

export {
  savePedidoVoo,
  updatePedidoVoo,
  findPedidoVooById,
  findPedidoVooArquivosById,
  validatePedidoVoo,
  deletePedidoVoo,
  pedidoVooClearSelected,
};
